import { InjectionToken } from '@angular/core';
import { MojoPrivilegesService } from 'mojo-privileges';

export const GLOBAL_PRIVILEGES = new InjectionToken<MojoPrivilegesService>(
  'mojo-global-privileges-service',
);
